<img *ngIf="showFileDialog && whitelabeled && !orgimage" class="img-long-bg shadow" data-toggle="collapse"
  [attr.data-target]="'#orgLogoModal'+uid" src="" />

<!---<img *ngIf="whitelabeled && showFileDialog && imgtype == 'rect' && orgimage && !cropperready" class="img-long-bg shadow"
  data-toggle="collapse" [attr.data-target]="'#imagecollapse'+uid" src="{{orgimage.orgimageurl}}"
  (error)="refreshUrl()" />--->

<img *ngIf="whitelabeled && !showFileDialog && imgtype == 'rect' && orgimage" class="img-long"
  src="{{orgimage.orgimageurl}}" (error)="refreshUrl()" />

<img *ngIf="whitelabeled && showFileDialog && imgtype == 'square' && orgimage" class="img-thumbnail shadow"
  data-toggle="collapse" [attr.data-target]="'#imagecollapse'+uid" src="{{orgimage.orgimageurl}}"
  (error)="refreshUrl()" />

<img *ngIf="!useraccount && whitelabeled && !showFileDialog && imgtype == 'square' && orgimage"
  class="img-thumbnail-small " src="{{orgimage.orgimageurl}}" (error)="refreshUrl()" />

<img *ngIf="useraccount && whitelabeled && !showFileDialog && imgtype == 'square' && orgimage"
  class="img-thumbnail-small" style="margin-top: 20px;" src="{{orgimage.orgimageurl}}" (error)="refreshUrl()" />

<img *ngIf="!whitelabeled" height="47px" data-toggle="modal" [attr.data-target]="'#orgLogoModal'+uid"
  src="../../../assets/images/logo-clearramp-light.png">

<!-- <svg *ngIf="!whitelabeled" data-toggle="modal" [attr.data-target]="'#orgLogoModal'+uid" class="d-inline-block align-top cursor-pointer"  width="40px" version="1.1" id="Lag_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 134 134" style="enable-background:new 0 0 134 134; height: 80px; margin-top: 3px;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:#899878;}
    .st1{fill:#FFFFFF;}
    .st2{font-family:'Montserrat-SemiBold';}
    .st3{font-size:109px;}
  </style>
  <g>
    <path class="st0" d="M0,124c0,5.5,4.5,10,10,10h114c5.5,0,10-4.5,10-10V10c0-5.5-4.5-10-10-10H10C4.5,0,0,4.5,0,10V124z"/>
  </g>
  <text transform="matrix(1 0 0 1 24.0059 99.8057)" class="st1 st2 st3">K</text>
</svg> -->

<div *ngIf="whitelabeled && showFileDialog && imgtype == 'rect' && orgimage" class="">
  <div class="text-center">
    <p *ngIf="whitelabeled && showFileDialog && imgtype == 'rect' && orgimage && !cropperready"
      class="text-muted text-center mb-0">{{ 'orgaccount.clickimages' | trans }}</p>
    <label *ngIf="!cropperready" (click)="imageUpload.click()" class="file-container" id="validatorcustom">
      <span *ngIf="whitelabeled && showFileDialog && imgtype == 'rect' && orgimage && !cropperready"
        class="file-container-name">{{ 'orgaccount.rectangularlogo' | trans }}</span>
      <img *ngIf="whitelabeled && showFileDialog && imgtype == 'rect' && orgimage && !cropperready"
        class="img-long-bg shadow" src="{{orgimage.orgimageurl}}" (error)="refreshUrl()" />
    </label>
    <input type="file" (change)="fileChangeEvent($event)" class="d-none" id="validatedCustomFile" #imageUpload required>
  </div>
  <p *ngIf="cropperready" class="text-muted pb-0 mb-0 pt-2">{{ 'orglogo.croptofit' | trans }}</p>
  <image-cropper *ngIf="imageChangedEvent" class="file-border p-0" [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true" [aspectRatio]="4 /1" format="png" [resizeToWidth]="400"
    (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"></image-cropper>
  <p *ngIf="cropperready" class="text-muted pb-0 mb-0 pt-2">{{ 'orglogo.previewcrop' | trans }}</p>
  <img *ngIf="cropperready" class="mt-2 w-100 file-border" [src]="croppedImage" />
  <div class="row">
    <div class="col">
      <button *ngIf="cropperready" type="button" (click)="logoreset()" class="btn-close mt-2" name="save_rect_{{uid}}">
        <p class="btn-save-text">{{ 'orgstyle.cancel' | trans }}</p>
      </button>
    </div>
    <div class="col">
      <button *ngIf="cropperready" type="button" (click)="onDocumentSubmit('rect')" class="btn-save mt-2"
        name="save_rect_{{uid}}">
        <p class="btn-save-text">{{ 'orgsettings.savechanges' | trans }}</p>
      </button>
    </div>
  </div>
</div>

<!---<div *ngIf="imgtype == 'square'" class="collapse mt-2" id="imagecollapse{{uid}}">
  <div class="custom-file mt-1 pt-1 mb-2">
    <input type="file" (change)="fileChangeEvent($event)" class="custom-file-input" id="validatedCustomFile" required>
    <label class="custom-file-label" for="validatedCustomFile">{{selectedFiles ? selectedFileName : 'orglogo.fileplace'
      | trans }}</label>
  </div>
  <p *ngIf="cropperready" class="text-muted pb-0 mb-0 pt-2">{{ 'orglogo.croptofit' | trans }}</p>
  <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1 /1"
    [resizeToWidth]="200" format="png" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"></image-cropper>
  <p *ngIf="cropperready" class="text-muted pb-0 mb-0 pt-2">{{ 'orglogo.previewcrop' | trans }}</p>
  <img *ngIf="cropperready" class="p-1 pt-2 w-100" [src]="croppedImage" />
  <button *ngIf="cropperready" type="button" data-toggle="collapse" [attr.data-target]="'#imagecollapse'+uid"
    (click)="onDocumentSubmit('square')" class="btn-save mt-2" name="save_square_{{uid}}">
    <p class="btn-save-text">{{ 'orgsettings.savechanges' | trans }}</p>
  </button>
</div>-->